var map = {
	"./advertising_0.webp": 89623,
	"./cybersecurity_0.webp": 3714,
	"./insurance_0.webp": 40697,
	"./legal_0.webp": 85336,
	"./luxury_0.webp": 11548,
	"./luxury_1_qr.webp": 84827,
	"./news_1.webp": 38629,
	"./social_0.webp": 42982,
	"./social_1.webp": 57825,
	"./vetraai_logo_advertising_1.webp": 45105,
	"./vetraai_logo_social_1.webp": 63898,
	"./vetraai_logo_white.webp": 13574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74632;